<div class="row">
  <div class="col-sm-6 col-md-3 mt-3">
    <div class="card panel-body card-list-item card-border" (click)="redirectCEMS(cardDetail['otherDetails']['total_ind_id'])" >
      <div class="d-flex align-items-start mb-0">
        <div class="flex-grow-1">
          <h6 style="font-size: 14px;" class="mb-0 fw-semibold">Total No. of Unit Stations connected on CEMS</h6>
          <strong [CountTo]="cardDetail['total']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['total']" style="font-size: 40px; color: #86CE6D;"></strong>
          <strong *ngIf="!industryCardLoader && !cardDetail['total']" style="font-size: 40px; color: #86CE6D;">{{cardDetail['total']}}</strong>
          <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
        </div>
        <div class="ms-3">
          <!--<i style="color: #86CE6D;" class="icon-pulse2 icon-2x opacity-75"></i>-->
          <img src="../../assets/images/icons/2.png">
        </div>
      </div>
      <!--<div class="progress progress-micro mb-10">
        <div class="progress-bar bg-danger-400" style="background-color: #FB6058; width: 80%">
          <span class="sr-only">13% Increase</span>
        </div>
      </div>
      13% Increase -->
    </div>
  </div>

  <div class="col-sm-6 col-md-3 mt-3">
    <div class="card panel-body card-list-item card-border" (click)="redirectCEMS(exceedDetail['otherDetails']['ind_id'])" >
      <div class="d-flex align-items-start mb-0">
        <div class="flex-grow-1">
          <!-- <h6 style="font-size: 14px;" class="mb-0 fw-semibold">No of Unit Stations exceeds parameters</h6> -->
          <h6 style="font-size: 14px;" class="mb-0 fw-semibold">No of Unit Industries exceeds parameters</h6>
          <strong [CountTo]="exceedDetail['exceedance']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && exceedDetail['exceedance']" style="font-size: 40px; color: #FB6058;"></strong>
          <strong *ngIf="!industryCardLoader && !exceedDetail['exceedance']" style="font-size: 40px; color: #FB6058;">{{exceedDetail['exceedance']}}</strong>
          <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
        </div>
        <div class="ms-3">
          <!--<i class="icon-pulse2 icon-2x text-danger-400 opacity-75"></i>-->
          <img src="../../assets/images/icons/8.png">
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-6 col-md-3 mt-3">
    <div class="card panel-body card-list-item card-border" (click)="redirectCEMS(cardDetail['otherDetails']['close_ind_id'])" >
      <div class="d-flex align-items-start mb-0">
        <div class="flex-grow-1">
          <h6 style="font-size: 14px;" class="mb-0 fw-semibold">No. of Unit Stations where CEMS is not functioning</h6>
          <strong [CountTo]="cardDetail['close']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['close']" style="font-size: 40px; color: #814EC1;"></strong>
          <strong *ngIf="!industryCardLoader && !cardDetail['close']" style="font-size: 40px; color: #814EC1;">{{cardDetail['close']}}</strong>
          <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
        </div>
        <div class="ms-3">
          <!--<i style="color: #814EC1;" class="icon-pulse2 icon-2x opacity-75"></i>-->
          <img src="../../assets/images/icons/3.png">
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-6 col-md-3 mt-3">
    <div class="card panel-body card-list-item card-border" (click)="redirectCEMS(cardDetail['otherDetails']['air_ind_id'])" >
      <div class="d-flex align-items-start mb-0">
        <div class="flex-grow-1">
          <h6 style="font-size: 14px;" class="mb-0 fw-semibold">No of Air Emission Unit Stations connected</h6>
          <strong [CountTo]="cardDetail['air']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['air']" style="font-size: 40px; color: #919191;"></strong>
          <strong *ngIf="!industryCardLoader && !cardDetail['air']" style="font-size: 40px; color: #919191;">{{cardDetail['air']}}</strong>
          <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
        </div>
        <div class="ms-3">
          <!--<i style="color: #919191;" class="icon-pulse2 icon-2x opacity-75"></i>-->
          <img src="../../assets/images/icons/6.png">
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-6 col-md-3 mt-3">
    <div class="card panel-body card-list-item card-border" (click)="redirectCEMS(cardDetail['otherDetails']['water_ind_id'])" >
      <div class="d-flex align-items-start mb-0">
        <div class="flex-grow-1">
          <h6 style="font-size: 14px;" class="mb-0 fw-semibold">No of  Water Effluent Unit Stations connected</h6>
          <strong [CountTo]="cardDetail['water']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['water']" style="font-size: 40px; color: #119DF3;"></strong>
          <strong *ngIf="!industryCardLoader && !cardDetail['water']" style="font-size: 40px; color: #119DF3;">{{cardDetail['water']}}</strong>
          <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
        </div>
        <div class="ms-3">
          <!--<i style="color: #119DF3;" class="icon-pulse2 icon-2x opacity-75"></i>-->
          <img src="../../assets/images/icons/7.png">
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-6 col-md-3 mt-3">
    <div class="card panel-body card-list-item card-border" (click)="redirectCEMS(cardDetail['otherDetails']['both_ind_id'])" >
      <div class="d-flex align-items-start mb-0">
        <div class="flex-grow-1">
          <h6 style="font-size: 14px;" class="mb-0 fw-semibold">No of Air and Water Unit Stations connected</h6>
          <strong [CountTo]="cardDetail['both']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['both']" style="font-size: 40px; color: #597988;"></strong>
          <strong *ngIf="!industryCardLoader && !cardDetail['both']" style="font-size: 40px; color: #597988;">{{cardDetail['both']}}</strong>
          <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
        </div>
        <div class="ms-3">
          <img src="../../assets/images/icons/5.png">
        </div>
      </div>
    </div>
  </div>
</div>
